import ApiFactory from './factory'
import declaration from './declarations'
import { publicConfig } from '@/config/runtime'

/** @type {ApiFactory & Record<string, any>} */
const Api = new ApiFactory(() => `${publicConfig().apiBaseUrl}v3`, declaration)

export default Api
